import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEditFiltersIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      d="M1 15h1.098L12.796 4.302l-1.098-1.098L1 13.902zm-.192 1a.78.78 0 0 1-.576-.232.78.78 0 0 1-.232-.576v-1.04q0-.332.13-.632t.349-.518L13.18.287a1.2 1.2 0 0 1 .339-.212Q13.705 0 13.907 0q.203 0 .39.064a.9.9 0 0 1 .35.228l1.067 1.074q.165.16.226.35.06.19.06.38 0 .204-.068.39a1 1 0 0 1-.218.339L2.998 15.521a1.64 1.64 0 0 1-1.15.479zm11.43-12.238-.54-.558 1.098 1.098z"
    />
  </svg>
)
export default SvgEditFiltersIcon
